/* eslint-disable no-unused-vars */
/*
 * @Description: api请求管理
 * @Author: yingbin
 * @Date: 2019-08-22 17:02:38
 * @LastEditTime: 2019-09-09 17:19:50
 * @LastEditors: yingbin
 */
import { Message } from 'element-ui';
import request from '@/utils/request'
import utils from '@/utils/utils';
import md5 from "js-md5";
class userApi {
	// 注册
	register(self) {
		return new Promise((resolve, reject) => {
			request.post(self, {
				action: "user.regist",
				url:'/user/regist',
				data: {
					"password": md5(self.registerForm.password),
					"mobile": self.registerForm.phone,
					"smsCode": self.registerForm.phoneCode,
					"req_time": new Date().getTime(),
				}
			}).then(res => {
				if (res.code == 20000) {
					resolve({
						success: true,
						data: res.data
					})
				} else {
					Message.error(res.message)
				}
			})
		})
	}

	//登录
	login(self) {
		return new Promise((resolve, reject) => {
			request.post(self, {
				action: "user.login",
				url:'/user/login',
				data: {
					"captchaType": "blockPuzzle", //行为校验方式  滑动
					"captcha": self.captcha,
					"mobile": self.loginForm.name,
					"password": md5(self.loginForm.password),
					"req_time": self.req_time,
				}
			}).then(res => {
				if (res.code == 20000) {
					resolve({
						success: true,
						data: res.data
					})
				} else {
					Message.error(res.message)
				}
			})
		})
	}

	// 获取图片验证码
	getImgCode(self) {
		return new Promise((resolve, reject) => {
			request.post(self, {
				action: "common.getimgcode",
				url:'/common/getimgcode',
				data: {
					"req_time": new Date().getTime()
				}
			}).then(res => {
				// console.log(res);
				if (res.code == 20000) {
					resolve({
						success: true,
						data: res.data
					})
				} else {
					self.$message.error(res.message)
				}
			})
		})
	}
	// 校验图片验证码
	checkImgCode(self) {
		return new Promise((resolve, reject) => {
			request.post(self, {
				action: "common.checkimgcode",
				url:'/common/checkimgcode',
				data: {
					"imgCode": self.registerForm.picutureCode,
					"req_time": self.req_time,
				}
			}).then(res => {
				if (res.code == 20000) {
					resolve({
						success: true,
						data: res.data
					})
				} else {
					self.changeCode()
					self.$message.error(res.message)
				}
			})
		})
	}

	// 获取短信验证码 根据用户名
	getMessageCodeByName(self) {
		return new Promise((resolve, reject) => {
			request.post(self, {
				action: "user.changemobile.messagecode",
				url:"/user/changemobile/messagecode",
				data: {
					"userName":utils.getCookie("USER_INFO"),
					"token": utils.getCookie('TOKEN'),
					"imgCode":self.oldParams.imgCode,
					"req_time": self.req_time,
				}
			}).then(res => {
				if (res.code == 20000) {
					resolve({
						success: true,
						data: res.data
					})
				} else {
					if(self.userChangeCode){
						self.userChangeCode()
					}
					self.$message.error(res.message)
				}
			})
		})
	}

	// 忘记密码 第一步
	rewritePswd(self) {
		return new Promise((resolve, reject) => {
			request.post(self, {
				action: "user.retrievepwd",
				url:'/user/retrievepwd',
				data: {
					"captchaType": "blockPuzzle", //行为校验方式  滑动
					"captcha": self.captcha,
					"smsCode": self.messageCode,
					"mobile": self.mobile,
					"token": utils.getCookie('TOKEN'),
					"req_time": new Date().getTime()
				}
			}).then(res => {
				if (res.code == 20000) {
					resolve({
						success: true,
						data: res.data
					})
				} else {
					Message.error(res.message)
				}
			})
		})
	}

	// 忘记密码 第二步
	resetpwd(self) {
		return new Promise((resolve, reject) => {
			request.post(self, {
				action: "user.resetpwd",
				url:'/user/resetpwd',
				data: {
					"mobile": self.mobile,
					"checkCode":self.checkCode,
					"token": utils.getCookie('TOKEN'),
					"password": md5(self.newPswd),
					"req_time": new Date().getTime()
				}
			}).then(res => {
				if (res.code == 20000) {
					resolve({
						success: true,
						data: res.data
					})
				} else {
					Message.error(res.message)
				}
			})
		})
	}

	// 忘记密码 获取手机验证码
	resetGetCode(self){
		return new Promise((resolve, reject) => {
			request.post(self, {
				action: "user.smscode",
				url:"/user/smscode",
				data: {
					"userName": self.pswdForm_step1.name,
					"captchaType": "blockPuzzle", //行为校验方式  滑动
					"captcha": self.captcha,
				}
			}).then(res => {
				if (res.code == 20000) {
					resolve({
						success: true,
						data: res.data
					})
				} else {
					Message.error(res.message)
				}
			})
		})
	}

	/**  修改密码 */
	chanegPassword(self){
		return new Promise((resolve, reject) => {
			request.post(self, {
				action: "user.changepwd",
				url:'/user/changepwd',
				data: {
					"userName":utils.getCookie("USER_INFO"),
					"oldPassword": md5(self.passwordForm.oldPassword),
					"newPassword": md5(self.passwordForm.newPassword), 
					"token": utils.getCookie("TOKEN"),
					"req_time": self.req_time
				}
			}).then(res => {
				if (res.code == 20000) {
					resolve({
						success: true,
						data: res.data
					})
				} else {
					resolve({
						success: false
					})
					Message.error(res.message)
				}
			})
		})
	}

	/** 验证本人手机 */
	changeOldMobile(self){
		return new Promise((resolve, reject) => {
			request.post(self, {
				action: "user.changemobile",
				url:"/user/changemobile",
				data: {
					"mobile":utils.getCookie("USER_INFO"),
					"smsCode": self.oldParams.phoneCode,
					"token": utils.getCookie('TOKEN'),
					"req_time": self.req_time
				}
			}).then(res => {
				if (res.code == 20000) {
					resolve({
						success: true,
						data: res.data
					})
				} else {
					Message.error(res.message)
				}
			})
		})
	}

	/** 变更手机号 */
	chengeMobile(self){
		return new Promise((resolve, reject) => {
			request.post(self, {
				action: "user.confirmmobile",
				url:"/user/confirmmobile",
				data: {
					"oldMoble":utils.getCookie("USER_INFO"),
					"newMobile": self.mobile,
					"smsCode": self.messageCode,
					'checkCode':self.checkCode,
					"token": utils.getCookie('TOKEN'),
					"req_time": new Date().getTime()
				}
			}).then(res => {
				if (res.code == 20000) {
					resolve({
						success: true,
						data: res.data
					})
				} else {
					Message.error(res.message)
				}
			})
		})
	}

	/** 变更手机号发送短信 */
	changeMobileGetCode(self){
		return new Promise((resolve, reject) => {
			request.post(self, {
				action: "user.confirmmobile.messagecode",
				url:"/user/confirmmobile/messagecode",
				data: {
					"userName":utils.getCookie("USER_INFO"),
					"mobile": self.newParams.phone,
					"token": utils.getCookie('TOKEN'),
				}
			}).then(res => {
				if (res.code == 20000) {
					resolve({
						success: true,
						data: res.data
					})
				} else {
					Message.error(res.message)
				}
			})
		})
	}

	// 获取用户信息  ref true强制刷新用户信息   默认false
	getUserInfo(self,ref) {
		return new Promise((resolve, reject) => {
			request.post(self, {
				action: "user.getuserinfo",
				url:'/user/getuserinfo',
				data: {
					"token": utils.getCookie('TOKEN'),
				}
			}).then(res => {
				if (res.code == 20000) {
					resolve({
						success: true,
						data: res.data
					})
				}else if(parseInt(res.code/10000) === 2){ //登录失效
					utils.removeCookie("USER_INFO");
					self.$store.commit("USER_INFO", '');
					self.$toast(true);  //跳出登录弹窗				
				} else {
					Message.error(res.message)
				}
			})
		})
	}

	// 退出登录
	loginOut(self) {
		return new Promise((resolve, reject) => {
			request.post(self, {
				action: "user.logout",
				url:'/user/logout',
				data: {
					"token": utils.getCookie('TOKEN'),
				}
			}).then(res => {
				if (res.code == 20000) {
					resolve({
						success: true,
						data: res.data
					})
				} else {
					Message.error(res.message)
				}
			})
		})
	}
	//滑动验证登录
	slideLogin(self) {
		return new Promise((resolve, reject) => {
			request.post(self, {
				action: "user.login.v2",
				url: '/user/login/v2',
				data: {
					"mobile": self.pohneLogin.phone,
					"smsCode": self.pohneLogin.phoneCode,
					"req_time": new Date().getTime()
				}
			}).then(res => {
				if (res.code == 20000) {
					resolve({
						success: true,
						data: res.data
					})
				} else {
					Message.error(res.message)
				}
			})
		})
	}
	//滑动验证登录获取短信验证码
	sendsmscode(self) {
		return new Promise((resolve, reject) => {
			request.post(self, {
				action: "user.sendsmscode",
				url: '/user/sendsmscode',
				data: {
					"captchaType": "blockPuzzle", //行为校验方式  滑动
					"smsType":self.smsType,
					"mobile": self.mobile,
					"captcha": self.captcha,
					"token":self.token,
					"req_time": new Date().getTime()
				}
			}).then(res => {
				if (res.code == 20000) {
					resolve({
						success: true,
						data: res.data
					})
				} else {
					Message.error(res.message)
				}
			})
		})
	}
	//手机快捷登录 第一设置密码
	firstSetPwd(self) {
		return new Promise((resolve, reject) => {
			request.post(self, {
				action: "user.initpwd",
				url: '/user/initpwd',
				data: {
					"token": utils.getCookie('TOKEN'),
					"username":utils.getCookie("USER_INFO"),
					"password": md5(self.setPassword.newPassword2),
				}
			}).then(res => {
				if (res.code == 20000) {
					resolve({
						success: true,
						data: res.data
					})
				} else {
					Message.error(res.message)
				}
			})
		})
	}
}
export default new userApi();